import Firebase from '../services/firebase'
import React, {Component} from "react"
import PropTypes from 'prop-types'
import { Button, Divider, Form, Grid, Header, Icon, Message, Segment } from "semantic-ui-react";
import * as firebase from "firebase";

export class SignupPageTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailAddress: "",
      password: "",
      confirmedPassword: "",
      emailButtonText:"Submit",
      emailButtonTextAnimation:"Let's have a GOOD time",
      validSubmit: false,
      user: null,
      loading: true

    };

    Firebase.auth().onAuthStateChanged(function (user) {

      if (user) {
        // User is signed in.
        this.setState({ 'user':  Firebase.auth().currentUser });
        this.setState({ 'loading': false });
      } else {
        // No user is signed in.
        this.setState({ 'user': null });
        this.setState({ 'loading': false });
      }
    }.bind(this)).bind(this);

    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handlePasswordConfirmaitonChange = this.handlePasswordConfirmaitonChange.bind(this);

    this.emailLogin = this.emailLogin.bind(this);
    this.updateValidButtonSubmit = this.updateValidButtonSubmit.bind(this);

  }

  handleEmailChange = e => {
    this.setState({ 'emailAddress': e.target.value });
    this.updateValidButtonSubmit();


  };

  handlePasswordChange = e => {
    this.setState({ 'password': e.target.value });
  };

  handlePasswordConfirmaitonChange = e => {
    this.setState({ 'confirmedPassword': e.target.value });
  };

  updateValidButtonSubmit = () => {
    let isValid = ((this.state.password === this.state.confirmedPassword) && (this.state.password !== "")  );
    this.setState({ 'validSubmit': isValid });
  };

  validateEmail= email =>{
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    return re.test(String(email).toLowerCase());
  }

  facebookLogin = async () => {
    const provider = new firebase.auth.FacebookAuthProvider();
    return firebase.auth().signInWithRedirect(provider).then(function() {
      if(typeof window !== 'undefined'){
        window.location.replace('/')
      }
    })
  };


  emailLogin =  () => {
    const { password, confirmedPassword } = this.state;
    if (password !== confirmedPassword) {
      alert("Please enter a valid email, and make sure your passwords match.");
      return;

    } else {
      Firebase.auth().createUserWithEmailAndPassword(this.state.emailAddress, this.state.password)
      .catch(function(error) {
        var errorMessage = error.message;
        alert(errorMessage);
      }).then(function() {
        if(typeof window !== 'undefined'){
          window.location.replace('/')
        }
      })
    }
  };

  render() {
    return (
      <div>
        <div
          style={{
            display: 'flex',
            height: '100%',
            lineHeight: '1',
            justifyContent: 'space-around',
            alignItems: 'left',
            flexDirection: 'column',
          }}
        >
        </div>
        <div className="content has-text-centered">
          <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
            <Grid.Column style={{ maxWidth: 450 }}>
              <Header as='h2' color='blue' textAlign='center'>
                Welcome to Good Music Good Times!
              </Header>
              <Form className='large' >
                <Segment stacked>
                  <Message
                    attached
                    header='Fill out the form below to sign-up for a new account'
                  />
                  <Form.Group widths='equal'>
                  </Form.Group>
                  <Form.Field>
                    <input placeholder='Email Address' type='text' onInput={this.handleEmailChange}/>
                  </Form.Field>
                  <Form.Field>
                    <input placeholder='Password' type='password' onInput={this.handlePasswordChange}/>
                  </Form.Field>
                  <Form.Field>
                    <input placeholder='Confirm Password' type='password' onInput={this.handlePasswordConfirmaitonChange} />
                  </Form.Field>
                  <Form.Checkbox inline label='I agree to the terms and conditions' />
                  <Button animated='slide'  fluid size='large' color='blue' onClick={this.emailLogin}>
                    <Button.Content visible>{this.state.emailButtonText}</Button.Content>
                    <Button.Content hidden>
                      {this.state.emailButtonTextAnimation}
                    </Button.Content>
                  </Button>
                  <Divider horizontal>Or</Divider>
                  <Button  animated='slide' color='facebook' fluid size='large' onClick={this.facebookLogin}>
                    <Button.Content visible> <Icon name='facebook' />
                      &nbsp;  &nbsp; Sign Up With Facebook
                    </Button.Content>
                    <Button.Content hidden>
                      <Icon name='facebook' /> &nbsp;  &nbsp;That's a GOOD choice
                    </Button.Content>
                  </Button>
                </Segment>
              </Form>
              <Message>
                Already signed up?&nbsp;<a href='/login'>Login here</a>&nbsp;instead.
              </Message>
            </Grid.Column>
          </Grid>
        </div>
      </div>
    );
  }
}

SignupPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  mainpitch: PropTypes.object,
  description: PropTypes.string,
  intro: PropTypes.shape({
    blurbs: PropTypes.array,
  }),
};

const SignupPage = ({ data }) => {
  return (
    <div>
      <SignupPageTemplate />
    </div>

  )
};

SignupPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
};

export default SignupPage;
